import loadable from '@loadable/component';

export const PrenotazioneView = loadable(() =>
  import('./PrenotazioneView/PrenotazioneView'),
);

export const PrenotazioniFolderView = loadable(() =>
  import('./PrenotazioniFolderView/PrenotazioniFolderView'),
);

export const PrenotazioniExportView = loadable(() =>
  import('./PrenotazioniExportView/PrenotazioniExportView'),
);

export const AreaPersonaleView = loadable(() =>
  import('./AreaPersonaleView/AreaPersonaleView'),
);
